import { render } from "./App.vue?vue&type=template&id=0947050a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0947050a&lang=css"

import exportComponent from "C:\\Users\\EDY\\Desktop\\website2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__